import { trackEvent } from "../utils/track-event";
import type { TrackingEvent, TrackingEventResponse } from "../utils/types";

type ReturnLinkRequestedProps = {
  orderNumber: string;
  email: string;
};

type ReturnLinkRequestedAnalyticsProps = {
  order_number: string;
  email: string;
};

export type ReturnLinkRequestedEvent = TrackingEvent<
  "Return Link Requested",
  ReturnLinkRequestedAnalyticsProps
>;

export async function trackReturnLinkRequestedEvent({
  orderNumber,
  email,
}: ReturnLinkRequestedProps): TrackingEventResponse {
  return await trackEvent("Return Link Requested", {
    props: {
      order_number: orderNumber,
      email,
    },
    withRequestSource: true,
  });
}
